import React, { useState } from 'react';
import CommonContainer from "../components/CommonContainer";
import { useDocTitle } from '../components/CustomHook';
import axios from 'axios';
// import emailjs from 'emailjs-com';
import Notiflix from 'notiflix';
import CustomInputField from '../components/CustomInputField';
import { EMAIL_INVALID_MESSAGE, EMAIL_REQUIRED_MESSAGE, FIRST_NAME_INVALID_MESSAGE, FIRST_NAME_REQUIRED_MESSAGE, LAST_NAME_INVALID_MESSAGE, LAST_NAME_REQUIRED_MESSAGE, MAX_LENGTH_VALIDATE_MESSAGE, MESSAGE_REQUIRED, MIN_LENGTH_ONE_CHARACTERS, MIN_LENGTH_VALIDATE_MESSAGE, PHONE_REQUIRED_MESSAGE } from '../utills/ApplicationConstants';
import { EMAIL_REGEX_PATTERN, ONLY_ALPHABETIC } from '../utills/ApplicationRegex';
import { Controller, useForm } from 'react-hook-form';
import CustomPhoneInput from '../components/CustomPhoneInput';
import { FormHelperText } from '@mui/material';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { BASE_URL, CONTACT } from '../utills/ApplicationRouting';
import toast, { Toaster } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import {FaXTwitter,FaFacebook,FaLinkedin,} from "react-icons/fa6";

const Contact = () => {
  
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [message, setMessage] = useState('')
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate('');



  const {
    handleSubmit,
    control,
    reset,
    setError,
    clearErrors,
    formState,
    setValue,
    formState: { errors },
  } = useForm();

  const handleInputChange = (e) => {
    setFirstName(e.target.value);
  };

  const handleLastNameChange = (e) => {
    setLastName(e.target.value);
  };

  const handleMessageChange = (e) => {
    setMessage(e.target.value);
  };

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };
  const onSubmit = (data) => {
    setIsLoading(true)
    const postData = {
      firstName: firstName.trim(),
      lastName: lastName.trim(),
      email: email.trim(),
      contact: data.phoneNumber,
      message: message.trim()
    };
console.log("contact",postData);


    // return;
    axios
      .post(`${BASE_URL}${CONTACT}`, postData)
      .then((response) => {
        console.log(response);

        if (response.status === 200) {
          console.log("success");
          toast.success("We got your request we'll get back to you soon");
          setIsLoading(false)
          // reset();
          setTimeout(() => {
            navigate("/");
          }, 3000);

        }
             })
             .catch((error) => {
              setIsLoading(false);
              if (error.response && error.response.data) {
                const errors = error.response.data; 
                if (typeof errors === "object") {
               
                  Object.keys(errors).forEach((key) => {
                    console.log(`${errors[key]}`); 
                    toast.error(`${errors[key]}`); 
                  });
                } else {
                  toast.error(errors); 
                }
              } 
            });
  };
  useDocTitle("Contact Us");

  return (
    <>
    <Toaster/>

    <div id="contact" className="flex justify-center items-center mt-0 w-full bg-white py-0 lg:py-0">
 <CommonContainer>
  <div className="my-8" data-aos="zoom-in">
    <div className="flex flex-wrap lg:flex-nowrap gap-8">
      {/* Left Box: Contact Form */}
      <form onSubmit={handleSubmit(onSubmit)} className="w-full h-fit lg:w-7/12 bg-white p-8 rounded-2xl shadow-2xl">
        <h1 className="font-bold text-center lg:text-left text-blue-900 uppercase text-4xl mb-6">Send us a message</h1>
        <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
          {/* First Name */}
          <CustomInputField
            requiredErrorMessage={FIRST_NAME_REQUIRED_MESSAGE}
            fieldPattern={ONLY_ALPHABETIC}
            patternErrorMessage={FIRST_NAME_INVALID_MESSAGE}
            minLength={2}
            minLengthErrorMessage={MIN_LENGTH_VALIDATE_MESSAGE}
            maxLength={60}
            maxLengthErrorMessage={MAX_LENGTH_VALIDATE_MESSAGE}
            fieldName="firstName"
            fieldId="firstName"
            fieldType="text"
            fieldLabel="First Name"
            fieldControl={control}
            fieldError={errors}
            fieldRequiredIcon="*"
            value={firstName}
            multiline={true}
            onInput={handleInputChange}
          />
          {/* Last Name */}
          <CustomInputField
            fieldName="lastName"
            requiredErrorMessage={LAST_NAME_REQUIRED_MESSAGE}
            fieldPattern={ONLY_ALPHABETIC}
            patternErrorMessage={LAST_NAME_INVALID_MESSAGE}
            minLength={1}
            minLengthErrorMessage={MIN_LENGTH_ONE_CHARACTERS}
            maxLength={60}
            maxLengthErrorMessage={MAX_LENGTH_VALIDATE_MESSAGE}
            fieldId="lastName"
            fieldType="text"
            fieldLabel="Last Name"
            fieldControl={control}
            fieldError={errors}
            fieldRequiredIcon="*"
            value={lastName}
            multiline={true}
            onInput={handleLastNameChange}
          />
        </div>
        {/* Email */}
        <CustomInputField
          fieldName="email"
          requiredErrorMessage={EMAIL_REQUIRED_MESSAGE}
          fieldPattern={EMAIL_REGEX_PATTERN}
          patternErrorMessage={EMAIL_INVALID_MESSAGE}
          fieldId="login-email"
          fieldType="text"
          fieldLabel="Email"
          fieldRequiredIcon="*"
          fieldControl={control}
          fieldError={errors}
          value={email}
          onInput={handleEmailChange}
          className="mt-5"
        />
        {/* Phone */}
        <div className="mt-5">
          <Controller
            name="phoneNumber"
            control={control}
            rules={{
              required: PHONE_REQUIRED_MESSAGE,
              validate: {
                isValidPhoneNumber: (value) =>
                  isValidPhoneNumber(value) || "Invalid phone number",
              },
            }}
            render={({ field, fieldState }) => (
              <CustomPhoneInput
                fieldControl={control}
                label="Contact"
                clearErrors={clearErrors}
                country="US"
                value={field.value}
                onChange={(value) => field.onChange(value)}
                error={fieldState.invalid ? fieldState.error : null}
                helperText={fieldState.invalid ? fieldState.error?.message : ""}
              />
            )}
          />
        </div>
        {/* Message */}
        <div className="my-4">
          <CustomInputField
            fieldName="message"
            requiredErrorMessage={MESSAGE_REQUIRED}
            fieldId="message"
            fieldType="text"
            fieldLabel="Message"
            fieldRequiredIcon="*"
            fieldControl={control}
            fieldError={errors}
            value={message}
            multiline={true}
            rows={8}
            onInput={handleMessageChange}
          />
        </div>
        <div className="my-2">
          <button
            type="submit"
            id="submitBtn"
            className="uppercase text-sm font-bold tracking-wide bg-blue-900 hover:bg-blue-500 text-gray-100 p-3 rounded-lg w-full focus:outline-none focus:shadow-outline"
          >
            Send Message
          </button>
        </div>
      </form>

      {/* Right Box: Address and Social Links */}
      <div className="w-full lg:w-5/12 bg-blue-900 p-8 rounded-2xl text-white shadow-2xl h-fit ">
        <h6 className="text-white text-lg font-bold mb-4">Address</h6>
       
        <h6 className="text-white text-base font-bold mb-2">US</h6>
        <p className="text-sm">
        Mail Box 1298, <br/>
              505 20th St North, <br />
              Suite 1220, Birmingham, AL - 35203. <br />
          United States<br />
          <strong>Phone:</strong><a href="tel:"> +1 (205)-941-8432</a> <br />
        </p>
     

      {/* 5th block: India Address */}
        <h6 className="text-white text-base font-bold mb-2 mt-3">India</h6>
        <p className="text-sm">
        No 31, Vandavasi Road,<br />
        Vedachala Nagar,
        <br />
        Kanchipuram, TamilNadu, 631502.
        <br/>
          India<br/>
          <strong>Phone:</strong><a href="tel:"> +91 8015801544</a> <br />
        </p>

        {/* <h6 className="text-white text-xl font-bold mb-2 mt-3">Send an E-mail</h6>
                    <p className="text-gray-400">info@mld.ng</p> */}
                 
        <div className="flex items-center gap-3 mt-6">
  <a
    href="https://twitter.com/quadprosoft"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-6 h-6 border border-white/30 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaXTwitter className="text-xl text-[#153E75] group-hover:text-white" />
  </a>

  <a
    href="https://www.facebook.com/quadprosofttechnologiesinc"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-6 h-6 border border-white/30 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaFacebook className="text-xl text-[#153E75] group-hover:text-white" />
  </a>

  <a
    href="https://www.linkedin.com/company/quadprosoft-technologies"
    target="_blank"
    rel="noopener noreferrer"
    className="group w-6 h-6 border border-white/30 rounded-lg bg-white flex items-center justify-center shadow-sm hover:bg-[#153E75] hover:border-[#153E75] transition-all duration-300"
  >
    <FaLinkedin className="text-xl text-[#153E75] group-hover:text-white" />
  </a>
</div>
      </div>
    </div>
  </div>
  </CommonContainer>
</div>

   

    </>


  )
}

export default Contact;